export const textLinkIconAlignments = {
    left: 'left',
    right: 'right',
};
export const textLinkSizes = {
    large: 'large',
    medium: 'medium',
    small: 'small',
};
export const textLinkTypes = {
    primary: 'primary',
    secondary: 'secondary',
    secondaryAlternate: 'secondaryAlternate',
    tertiary: 'tertiary',
    tertiaryAlternate: 'tertiaryAlternate',
};
